import { SHIPMENT_EXCEPTION_RULES } from '@/constants/shipment-exception-rules';

export type ShipmentExceptionTypeSlug =
  | 'off-route'
  | 'delayed-pickup'
  | 'delayed-delivery'
  | 'no-movement'
  | 'tracker-separated';

type CatalogEntry = {
  title: string;
  description: () => string;
};

const CATALOG: Record<ShipmentExceptionTypeSlug, CatalogEntry> = {
  'off-route': {
    title: 'Route Deviation',
    description: () => 'The device is outside the planned route corridor.',
  },
  'delayed-pickup': {
    title: 'Delayed Pickup',
    description: () =>
      `The device has not left the origin on time (planned departure + ${SHIPMENT_EXCEPTION_RULES.delayedPickupGraceMinutes} min).`,
  },
  'delayed-delivery': {
    title: 'Delayed Delivery',
    description: () =>
      'The device has not reached the destination by the planned arrival time.',
  },
  'no-movement': {
    title: 'No Movement',
    description: () =>
      `The device has not moved more than ${SHIPMENT_EXCEPTION_RULES.noMovementDisplacementMeters} m in ${SHIPMENT_EXCEPTION_RULES.noMovementWindowMinutes} min.`,
  },
  'tracker-separated': {
    title: 'Tracker Separated',
    description: () =>
      `A tracker has separated more than ${SHIPMENT_EXCEPTION_RULES.trackerSeparatedProximityMeters} m from the rest of the shipment group.`,
  },
};

function catalogEntry(type: string): CatalogEntry | undefined {
  return CATALOG[type as ShipmentExceptionTypeSlug];
}

export function exceptionTypeTitle(type: string): string {
  return catalogEntry(type)?.title ?? type.replace(/-/g, ' ');
}

export function exceptionTypeDescription(type: string): string {
  return catalogEntry(type)?.description() ?? type.replace(/-/g, ' ');
}

export function exceptionListCardTitle(
  type: string,
  shipmentName: string | null | undefined,
  shipmentId: number,
): string {
  const name =
    shipmentName != null && String(shipmentName).trim() !== ''
      ? String(shipmentName)
      : `#${shipmentId}`;
  return `${exceptionTypeTitle(type)}: ${name}`;
}
